import { render, staticRenderFns } from "./RegoHistory.vue?vue&type=template&id=623293dc&scoped=true"
import script from "./RegoHistory.vue?vue&type=script&lang=js"
export * from "./RegoHistory.vue?vue&type=script&lang=js"
import style0 from "./RegoHistory.vue?vue&type=style&index=0&id=623293dc&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "623293dc",
  null
  
)

export default component.exports